// Shared by both forks.
import React, { createContext, useContext } from 'react';
import type { SearchResults } from '../types';

export type SearchContextValue = {
	searchTerm: string;
	setSearchTerm: React.Dispatch<React.SetStateAction<string>>;
	onValueChange: (e: React.ChangeEvent<HTMLInputElement> | undefined) => void;
	isLoadingResults: boolean;
	searchResults: SearchResults;
	clearResults: () => void;
	onClearButtonClick: () => void;
	defaultSearchAction: (recentSearchTerm?: string) => void;
	recentSearchTerms: string[];
	addSearchTermToRecentSearches: (term: string) => void;
};

export const SearchContext = createContext<SearchContextValue | null>(null);

export function useSearch() {
	const context = useContext(SearchContext);

	if (!context) {
		throw new Error('useSearch must be used within a SpotlightStateProvider');
	}

	return context;
}
